








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { VueCropper } from 'vue-cropper';

@Component({
  components: {
    VueCropper,
  },
})
export default class ImageCropper extends Vue {
  @Prop({ type: [String, File], default: '' }) readonly img!: string | File;
  @Prop({ type: Boolean, default: false }) readonly isShow!: boolean;
  @Prop({ type: Boolean, default: false }) isShowProportion!: boolean; // 是否开启比例选择功能
  visible: boolean = false;
  fileData: string | Blob = '';
  outputType: string = 'jpeg';
  proportion: number = 4;
  fixed_number: any = [];
  is_fixed: boolean = false;
  test: boolean = false;
  autoCrop: boolean = true;
  get isImgFile(): boolean {
    return Object.prototype.toString.call(this.img) === '[object File]';
  }

  @Watch('img')
  onImgChange(newVal: string | File) {
    if (typeof newVal === 'string') {
      this.fileData = newVal;
      this.visible = true;
      return;
    }
    if (this.isImgFile) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.fileData = e.target.result;
        this.visible = true;
      };
      reader.readAsDataURL(newVal);
    }
  }
  changeRadio() {
    this.autoCrop = false;
    this.is_fixed = true;
    switch (this.proportion) {
      case 1:
        this.fixed_number = [1, 1];
        break;
      case 2:
        this.fixed_number = [4, 3];
        break;
      case 3:
        this.fixed_number = [3, 4];
        break;
      case 4:
        this.fixed_number = [];
        this.is_fixed = false;
        break;
    }
    this.$nextTick(() => {
      this.autoCrop = true;
    });
  }

  crop() {
    (this.$refs.cropper as any).getCropBlob((data: Blob) => {
      const img: File = this.img as File;
      const isImgFile: boolean = this.isImgFile;
      const now = new Date();
      const file = new File([data], isImgFile ? img.name : `cropped-image.${this.outputType}`, {
        lastModified: +now,
      });
      this.$emit('crop', file);
      this.visible = false;
    });
  }

  cancel() {
    this.$emit('crop', false);
    this.visible = false;
    this.proportion = 4;
    this.fixed_number = [];
    this.is_fixed = false;
  }
}
